import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function TechnicalSkillsSectionItemContent(props) {
  const technologies = [...props.technologies];
  const { t } = useTranslation();

  useEffect(() => {
    for (let tech of technologies) {
      if (props.values?.map((x) => x.id).indexOf(tech.id) > -1) {
        props.setIsExpanded(true);
        break;
      }
    }
  }, [props.values]);

  return (
    <>
      {technologies.map((technology) => {
        return (
          <div className="form-check form-check-inline" key={technology.id}>
            <input
              className="form-check-input"
              type="checkbox"
              value={technology.id}
              checked={
                props.values?.map((x) => x.id).indexOf(technology.id) > -1
              }
              onChange={({ target }) =>
                props.onChange({
                  id: technology.id,
                  description: technology.description
                })
              }
              id={technology.description}
              name={technology.id}
            />
            <label className="form-check-label" htmlFor={technology.id}>
              {t(technology.description)}
            </label>
          </div>
        );
      })}
    </>
  );
}
